<template>
  <div class="page mx-auto">
    <div class="page-content">
      <div class="container text-center">
        <h1 class="text-muted mb-5">
          Billing and Invoicing
        </h1>
        <p class="h4 text-muted font-weight-normal mb-7">
          Coming soon!
        </p>
        <b-button
          variant="sm-primary"
          size="lg"
          @click="goBack"
        >
          <i class="fa-light fa-arrow-left mr-2" /> Go back
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Billing',

  methods: {
    goBack() {
      window.history.back();
    },
  },
};
</script>
